import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'fina-spinner',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './spinner.component.html',
    styleUrls: ['spinner.component.scss'],
})
export class SpinnerComponent {}
